import { Component, inject, OnInit } from '@angular/core'
import { finalize, take, tap } from 'rxjs'
import { PlanCardComponent } from '../plan-card/plan-card.component'
import { CommonModule } from '@angular/common'
import { PlanView, SubscriptionsService, SubscriptionStatus } from '../../../services/subscriptions'
import { Store } from '@ngrx/store'
import { selectSubscription, selectUser } from '../../../store/auth/auth.state'
import { Router } from '@angular/router'
import { eps } from '../../../services/url.service'

@Component({
  selector: 'app-plan-selection',
  imports: [PlanCardComponent, CommonModule],
  templateUrl: './plan-selection.component.html',
  styleUrl: './plan-selection.component.scss'
})
export class PlanSelectionComponent implements OnInit {
  store = inject(Store)
  router = inject(Router)
  isLoading = true
  billingCycle: 'Monthly' | 'Yearly' = 'Monthly'
  monthlyPlans: PlanView[] = []
  yearlyPlans: PlanView[] = []
  selectedPlanId: string | null = null
  currentPlanId: string | null = null
  user$ = this.store.select(selectUser)
  currentSubscription$ = this.store.select(selectSubscription)
  SubscriptionStatus = SubscriptionStatus

  constructor(private subscriptionsService: SubscriptionsService) {}

  ngOnInit() {
    this.isLoading = true
    this.user$.pipe(take(1)).subscribe(usr => {
      if (usr) {
        this.subscriptionsService
          .getPlansForBusiness(usr.businessId)
          .pipe(finalize(() => (this.isLoading = false)))
          .subscribe(response => {
            this.monthlyPlans = response.monthlyPlans
            this.yearlyPlans = response.yearlyPlans
          })
      }
    })
    this.currentSubscription$.pipe(take(1)).subscribe(sub => {
      sub?.planType === 'monthly' ? (this.billingCycle = 'Monthly') : (this.billingCycle = 'Yearly')
    })
  }

  setBillingCycle(cycle: 'Monthly' | 'Yearly'): void {
    this.billingCycle = cycle
  }

  handlePlanSelection(selectedPlan: PlanView): void {
    this.selectedPlanId = selectedPlan.id
    this.currentSubscription$
      .pipe(
        take(1),
        tap(sub => {
          if (sub?.subscriptionStatus === SubscriptionStatus.Trialing) {
            this.router.navigate([eps.planAndBilling.activatePlanPath, this.selectedPlanId])
          } else
            this.router.navigate([eps.planAndBilling.changePlanSummaryPath, this.selectedPlanId])
        })
      )
      .subscribe()
  }
}
